import React, { useState, useEffect, useMemo } from "react";
import Roadmap from "./libraryTab/Roadmap";
import Pidato from "./libraryTab/Pidato";
import Kajian from "./libraryTab/Kajian";
import Publikasi from "./libraryTab/Publikasi";
import Regulasi from "./libraryTab/Regulasi";
import Siaran from "./libraryTab/Siaran";
import Katalog from "./libraryTab/Katalog";
import BuletinInsight from "./libraryTab/BuletinInsight";
import { useTranslation } from "react-i18next";
import axios from "axios";
import Swal from "sweetalert2";
import { useCookies } from "react-cookie";
import InputGroup from "react-bootstrap/InputGroup";
import dayjs from "dayjs";
import "dayjs/locale/id";
import "dayjs/locale/en";

const Elibrary = () => {
    const [cookies] = useCookies(["i18next"]);
    const { t } = useTranslation();
    const [loading, setLoading] = useState(true);
    const [selectedSection, setSelectedSection] = useState("all");
    const [categories, setCategories] = useState([]);
    const [searchTitle, setSearchTitle] = useState("");
    const [files_all, setFilesData] = useState([]);

    const formatDate = (date, locale = "en") => {
        dayjs.locale(locale); // Set the locale dynamically
        return dayjs(date).format("DD MMMM YYYY"); // Format the date
    };

    const fetchCategories = async () => {
        const url = process.env.REACT_APP_API_URL;
        const response = await axios.get(`${url}/files_category`);
        return response.data;
    };

    useEffect(() => {
        const fetchData = async () => {
            setLoading(true);
            try {
                const data = await fetchCategories();
                setCategories(data);
            } catch (err) {
                Swal.fire({
                    icon: "error",
                    title: "Oops...",
                    text: err.message,
                });
            } finally {
                setLoading(false);
            }
        };
        fetchData();
    }, []);

    useEffect(() => {
        axios
            .get(process.env.REACT_APP_API_URL + "/files")
            .then((res) => setFilesData(res.data))
            .catch((err) => console.error(err));
    }, []);

    const filteredPosts = useMemo(() => {
        return files_all
            .filter(
                (filessearch) =>
                    filessearch.title &&
                    filessearch.title.toLowerCase().includes(searchTitle.toLowerCase()),
            )
            .sort((a, b) => new Date(b.date) - new Date(a.date));
    }, [files_all, searchTitle]);

    const [currentPage, setCurrentPage] = useState(1);
    const postsPerPage = 8;

    useEffect(() => {
        setCurrentPage(1);
    }, [searchTitle, selectedSection]);

    const lastPostIndex = currentPage * postsPerPage;
    const firstPostIndex = lastPostIndex - postsPerPage;
    const currentPosts = filteredPosts.slice(firstPostIndex, lastPostIndex);
    const totalPages = Math.ceil(filteredPosts.length / postsPerPage);

    const handlePageChange = (pageNumber) => {
        if (pageNumber !== "...") setCurrentPage(pageNumber);
    };

    const generatePaginationItems = () => {
        const paginationItems = [];
        const maxPageNumbersToShow = 10;
        let startPage, endPage;

        if (totalPages <= maxPageNumbersToShow) {
            startPage = 1;
            endPage = totalPages;
        } else {
            if (currentPage <= 6) {
                startPage = 1;
                endPage = maxPageNumbersToShow;
            } else if (currentPage + 4 >= totalPages) {
                startPage = totalPages - maxPageNumbersToShow + 1;
                endPage = totalPages;
            } else {
                startPage = currentPage - 5;
                endPage = currentPage + 4;
            }
        }

        for (let i = startPage; i <= endPage; i++) {
            paginationItems.push(i);
        }

        if (startPage > 1) paginationItems.unshift("...");
        if (endPage < totalPages) paginationItems.push("...");

        return paginationItems;
    };

    const componentMap = {
        1: Roadmap,
        2: Pidato,
        3: Kajian,
        7: Publikasi,
        5: Regulasi,
        6: Siaran,
        12: Katalog,
        13: BuletinInsight,
    };

    const renderContent = () => {
        if (selectedSection === "all") {
            return (
                <>
                    {currentPosts.map((item) => (
                        <div className="col-12 col-md-6 col-xl-3" key={item?.id}>
                            <div className="team-card-x">
                                <div className="team-card-img-x">
                                    <a href={`/e-pustaka/${item?.id}`}>
                                        <img
                                            src="/assets/image/book1.jpeg"
                                            className="img-fluid"
                                            alt="img-40"
                                        />
                                    </a>
                                </div>
                                <div className="team-card-content-x">
                                    <h4>
                                        <a href={`/e-pustaka/${item?.id}`}>
                                            {cookies.i18next === "en" ? item?.title_en : item?.title}
                                        </a>
                                    </h4>
                                    <div className="d-flex justify-content-between align-items-end">
                                        <p>
                                            {cookies.i18next === "id"
                                                ? formatDate(item.date, "id")
                                                : formatDate(item.date, "en")}
                                        </p>
                                        <a
                                            title="Downloadable"
                                            href={item?.file}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            download
                                        >
                                            <i
                                                className="fa-solid fa-download"
                                                aria-hidden="true"
                                            ></i>
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}
                    {totalPages > 1 && (
                        <div className="col-12 mt-4 d-flex justify-content-center">
                            <div
                                className="pagination d-flex align-items-center"
                                style={{ gap: "8px" }}
                            >
                                <button
                                    className="pagination-btn btn btn-sm btn-outline-secondary"
                                    onClick={() => handlePageChange(currentPage - 1)}
                                    disabled={currentPage === 1}
                                >
                                    <i className="fa-solid fa-chevron-left"></i> Prev
                                </button>
                                {generatePaginationItems().map((page, index) => (
                                    <button
                                        key={index}
                                        className={`pagination-btn ${page === currentPage ? "active" : ""}`}
                                        onClick={() => handlePageChange(page)}
                                        disabled={page === "..."}
                                        style={{ minWidth: "36px" }}
                                    >
                                        {page}
                                    </button>
                                ))}
                                <button
                                    className="pagination-btn btn btn-sm btn-outline-secondary"
                                    onClick={() => handlePageChange(currentPage + 1)}
                                    disabled={currentPage === totalPages}
                                >
                                    Next <i className="fa-solid fa-chevron-right"></i>
                                </button>
                            </div>
                        </div>
                    )}
                </>
            );
        }

        const Component = componentMap[selectedSection];
        return Component ? (
            <Component searchQuery={searchTitle} />
        ) : (
            <p>Pilih kategori untuk melihat konten.</p>
        );
    };

    return (
        <>
            <div className="page-wrapper">
                <section className="page-banner-perpus">
                    <div className="container">
                        <div className="page-banner-title">
                            <h3>{t("ePustaka")}</h3>
                        </div>
                    </div>
                </section>
                <section className="department-details-section">
                    <div className="container">
                        <div className="row">
                            <div className="col-12 col-lg-3 col-xl-3">
                                <div className="sidebar">
                                    <div className="sidebar-widget-list-inner">
                                        <ul>
                                            {loading
                                                ? Array.from({ length: 5 }).map((_, index) => (
                                                    <li key={index} className="skeletonxx"></li>
                                                ))
                                                : categories.map((category) => (
                                                    <li
                                                        key={category.id}
                                                        className={
                                                            String(selectedSection) === String(category.id)
                                                                ? "active"
                                                                : ""
                                                        }
                                                    >
                                                        <a
                                                            href="#t"
                                                            onClick={() => setSelectedSection(category.id)}
                                                        >
                                                            {cookies.i18next === "en"
                                                                ? category?.title_en
                                                                : category?.title}
                                                        </a>
                                                    </li>
                                                ))}
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-9">
                                <div className="row mb-4">
                                    <div className="col-12">
                                        <InputGroup className="shadow-sm">
                                            <input
                                                type="text"
                                                placeholder={t("cariEPustaka")}
                                                value={searchTitle}
                                                className="form-control form-control-lg border-0 bg-light"
                                                onChange={(e) => setSearchTitle(e.target.value)}
                                                style={{
                                                    borderRadius: "8px 0 0 8px",
                                                    paddingLeft: "20px",
                                                }}
                                            />
                                            <InputGroup.Text
                                                className="bg-light border-0"
                                                style={{
                                                    borderRadius: "0 8px 8px 0",
                                                    paddingRight: "20px",
                                                }}
                                            >
                                                <i
                                                    className="fa fa-search"
                                                    style={{ color: "#00a651" }}
                                                ></i>
                                            </InputGroup.Text>
                                        </InputGroup>
                                    </div>
                                </div>

                                <div className="row row-gutter-y-30">{renderContent()}</div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </>
    );
};

export default Elibrary;

